import React, { useEffect, useRef, useState } from 'react'
import Header from '../components/Header'
import Form from '../components/Form'
import Footer from '../components/Footer'
import BillTable from '../components/Table'
import { Alert, Box, Button, Container, Snackbar, Stack, Typography } from '@mui/material'
import axios from 'axios';
import CryptoJS from 'crypto-js';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import Grid from '@mui/material/Grid2';
import EntryForm from '../components/EntryForm'

export default function MainPage() {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [tableShow, setTableShow] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [openErrorMsg, setOpenErrorMsg] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [consumerId, setConsumerId] = useState("");
  const [isCorrectEncryption, setIsCorrectEncryption] = useState(true);
  const [isCorrectCaptchaVerify, setIsCorrectCaptchaVerify] = useState(false);

  const ref1 = useRef(null);

  const queryParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    if (queryParams.size > 0) {
      const encodeText = queryParams.get("consumerId");

      if (encodeText) {
        let encryptedConsumerId = decodeURIComponent(encodeText);
        console.log("decoded text: " + encryptedConsumerId);

        if (encryptedConsumerId) {
          var encryptedBase64Key = process.env.REACT_APP_QUERY_STRING_SECRET_KEY;
          var parsedBase64Key = CryptoJS.enc.Base64.parse(encryptedBase64Key);
          console.log(encryptedConsumerId, "query Param");
          try {
            // Decryption process
            var encryptedCipherText = encryptedConsumerId; // or encryptedData;
            var decryptedData = CryptoJS.AES.decrypt(encryptedCipherText, parsedBase64Key, {
              mode: CryptoJS.mode.ECB,
              padding: CryptoJS.pad.Pkcs7
            });
            // console.log( “DecryptedData = “ + decryptedData );

            // this is the decrypted data as a string
            var decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);
            console.log("DecryptedText = " + decryptedText);

            if (decryptedText.includes("#")) {
              var consumerId = decryptedText.split("#")[0];
              setConsumerId(consumerId);
              setIsCorrectEncryption(true);
            } else {
              setConsumerId("");
              setIsCorrectEncryption(false);
            }

          } catch (error) {
            setConsumerId("");
            setIsCorrectEncryption(false);
          }

        } else {
          setConsumerId("");
          setIsCorrectEncryption(false);
        }
      } else {
        setConsumerId("");
        setIsCorrectEncryption(false);
      }
    }
  }, [queryParams])


  function handleClick() {
    setLoading(true);
  }

  const executeScroll = (ref) => {
    if (ref && ref.current /* + other conditions */) {
      console.log("scroll", ref.current);
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
      console.log("scrolled");
    }
    else {
      console.log("NOOO", ref);
    }
    setLoading(false);
  }
  // run this function from an event handler or an effect to execute scroll 

  const handleTableShow = () => {
    setTableShow(false);
  }

  const fetchBillMonthData = (inputData) => {
    const message = inputData.consumerId + dayjs().format("YYYYMMDD");
    console.log(message);
    const secret = process.env.REACT_APP_ENC_SECRET_KEY;
    const cipherText = CryptoJS.HmacSHA256(message, secret);
    const encData = cipherText.toString(CryptoJS.enc.Base64);
    console.log(encData, "encData");

    axios.post(`${process.env.REACT_APP_API_URL}WBSEDCLPREPAYMENTMONTHLYSTATEMENTSCREENPOPULATION/PopulateMonthlyStatementTable`, {
      ...inputData,
      checkSum: encData
    }, {
      headers: {
        "Authorization": "Basic " + btoa(`${process.env.REACT_APP_BASIC_AUTH_USERNAME}:${process.env.REACT_APP_BASIC_AUTH_PASSWORD}`)
      }
    }).then((res) => {
      console.log(res.data, "Data");
      if (typeof res.data == "string") {
        setErrorMsg(t("Something went wrong. Please try again later"));
        handleErrorBar();
        setLoading(false);
      }
      else if (res.data?.EXCEPTION) {
        setErrorMsg(res.data?.EXCEPTION);
        handleErrorBar();
        setLoading(false);
      }
      else {
        setTableData(res.data);
        setTableShow(true);

        setTimeout(() => {
          executeScroll(ref1);
        }, 100);
        executeScroll(ref1);
      }
    })
      .catch((err) => {
        setErrorMsg(t("Something went wrong. Please try again later"));
        handleErrorBar();
        console.log(err, "Error");
        // let data = [
        //   {
        //     "consumerId": "100000149",
        //     "consumernName": "A A",
        //     "invoiceId": "100000048671",
        //     "invoiceDate": "20/04/2023",
        //     "dueAmount": "63413.88",
        //     "statementMonth": "APR,2023"
        //   },
        //   {
        //     "consumerId": "100000149",
        //     "consumernName": "A A",
        //     "invoiceId": "100000048673",
        //     "invoiceDate": "21/05/2023",
        //     "dueAmount": "77069.31",
        //     "statementMonth": "JUN,2023"
        //   },
        //   {
        //     "consumerId": "100000149",
        //     "consumernName": "A A",
        //     "invoiceId": "100000048907",
        //     "invoiceDate": "23/06/2023",
        //     "dueAmount": "80979.51",
        //     "statementMonth": "JUL,2023"
        //   },
        //   {
        //     "consumerId": "100000149",
        //     "consumernName": "A A",
        //     "invoiceId": "100000048908",
        //     "invoiceDate": "23/07/2023",
        //     "dueAmount": "84889.71",
        //     "statementMonth": "AUG,2023"
        //   }
        // ]

        // setTimeout(() => {
        //   setTableData(data);
        //   setTableShow(true);

        //   setTimeout(() => {
        //     executeScroll(ref1);
        //   }, 100);
        // }, 2000);



        setLoading(false);
        // executeScroll(ref1);
      })
  }

  const setDownloadError = () => {
    setErrorMsg(t("Something went wrong. Please try again later"));
  };

  const handleErrorBar = () => {
    setOpenErrorMsg(true);
  };

  const handleCloseErrorBar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenErrorMsg(false);
  };

  return (
    <div>
      <Header />
      <Snackbar open={openErrorMsg} autoHideDuration={30000} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} onClose={handleCloseErrorBar}>
        <Alert severity="error" onClose={handleCloseErrorBar} sx={{ width: '100%' }}>{errorMsg}</Alert>
      </Snackbar>
      {isCorrectEncryption && !isCorrectCaptchaVerify &&
        <>
          <Form prepopulatedConsumerId={consumerId} loading={loading} setLoading={handleClick} handleTableShow={handleTableShow} onVerifySubmit={(payload) => {
            setTableShow(false);

            // fetchBillMonthData(payload);
            setTimeout(() => {
              setIsCorrectCaptchaVerify(true);
              setLoading(false);
            }, 3000);
          }} />
          <Container component="main" maxWidth="xs" sx={{ mb: 10, mt: 5 }} ref={ref1}>
            {tableShow && <BillTable tableData={tableData} handleErrorBar={handleErrorBar} setDownloadError={setDownloadError} />}
          </Container>
        </>
      }
      {isCorrectCaptchaVerify &&
        <>
          <EntryForm prepopulatedConsumerId={consumerId} loading={loading} setLoading={handleClick} handleTableShow={handleTableShow} onVerifySubmit={(payload) => {
            setTableShow(false);

            // fetchBillMonthData(payload);
          }} />
        </>
      }
      {
        !isCorrectEncryption &&
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh'
          }}
        >
          <Container maxWidth="md">
            <Grid container spacing={2}>
              <Grid size={6}>
                <Typography variant="h1">
                  Oops...
                </Typography>
                <Typography variant="h4">
                  Something went wrong!
                </Typography>
                {/* <Button variant="contained">Back Home</Button> */}
              </Grid>
              <Grid size={6}>
                <img
                  src="images/error_page.png"
                  alt=""
                  width={500} height={250}
                />
              </Grid>
            </Grid>
          </Container>
        </Box>
      }
      <Footer />
    </div>
  )
}